import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const runSteps = [
  {
    number: 1,
    title: 'Prepare Your Body',
    description: 'Start with 5-10 minutes of light stretching and dynamic movements to warm up your muscles and joints.'
  },
  {
    number: 2,
    title: 'Find Your Rhythm',
    description: 'Begin at a comfortable pace. Focus on your breathing and let your body find its natural running rhythm.'
  },
  {
    number: 3,
    title: 'Stay Hydrated',
    description: 'Keep water accessible and take small sips regularly. Listen to your body\'s hydration needs.'
  },
  {
    number: 4,
    title: 'Enjoy the Journey',
    description: 'Take in the virtual scenery and sounds. Let the run be a meditative experience as much as physical activity.'
  }
];

const OutdoorRunSession1: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Outdoor Run Session 1',
      description: 'Completed Outdoor Run Session 1.',
      image: require('../assets/outdoor-run.png').default || require('../assets/outdoor-run.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/outdoor-run');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 1: Park Virtual Run</h1>
              <p className="session-description">
                Experience the joy of running through beautiful park scenery. Whether you're a beginner or seasoned runner, this virtual run will energize your body and mind.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/KiEN4HxM4ic"
                  title="Session 1: Outdoor Run"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Enjoy Your Run</h2>
                <div className="session-steps">
                  {runSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default OutdoorRunSession1;

